<template>
  <div class="documents">
    <div class="documents-info" v-if="isServiceShown">
      <icon name="warning-border--no-color" />
      <div
        class="documents-info__text"
        v-html="$t('event.documents.notification')"
      ></div>
    </div>

    <div v-if="acts && acts.length" class="documents-table__wrap">
      <div class="documents-table">
        <div class="documents-table__header">
          <div
            class="documents-table__col documents-table__col--number-contract"
          >
            {{ $t("event.documents.contractNumber") }}
          </div>

          <div class="documents-table__col documents-table__col--number-act">
            {{ $t("event.documents.numberAct") }}
          </div>

          <div class="documents-table__col documents-table__col--date">
            {{ $t("event.documents.date") }}
          </div>

          <div class="documents-table__col documents-table__col--sum-act">
            {{ $t("event.documents.sumAct") }}
          </div>

          <div class="documents-table__col documents-table__col--download">
            {{ $t("event.documents.downloadFile") }}
          </div>
        </div>
        <template v-for="item in acts">
          <simplebar :key="item.id">
            <div class="item-documents-table">
              <div class="documents-table__row">
                <div
                  class="documents-table__col documents-table__col--number-contract"
                >
                  <span class="documents-table__title-mobile">
                    {{ $t("event.documents.number") }}
                  </span>
                  {{ item.contract_number }}
                </div>

                <div
                  class="documents-table__col documents-table__col--number-act"
                >
                  <span class="documents-table__title-mobile">
                    {{ $t("event.documents.numberAct") }}
                  </span>
                  {{ item.number }}
                </div>

                <div class="documents-table__col documents-table__col--date">
                  <span class="documents-table__title-mobile">
                    {{ $t("event.documents.date") }}
                  </span>
                  {{ formatDate(item.document_date) }}
                </div>

                <div class="documents-table__col documents-table__col--sum-act">
                  <span class="documents-table__title-mobile">
                    {{ $t("event.documents.sum") }}
                  </span>
                  {{ item.amount | format }}&nbsp;{{
                    getCurrency(item.currency)
                  }}
                </div>

                <div
                  class="documents-table__col documents-table__col--download"
                >
                  <span class="documents-table__title-mobile">
                    {{ $t("event.documents.downloadFileShort") }}
                  </span>
                  <div
                    v-if="item.file"
                    class="documents-table__icon-download"
                    @click="downloadFile(item.id, item.number)"
                  >
                    <Tooltip
                      :label="$t('event.documents.downloadFileShort')"
                      position="left"
                    >
                      <icon name="download-transparent" />
                    </Tooltip>
                  </div>
                </div>
              </div>
              <div
                v-if="item.contents && item.contents.length"
                class="item-documents-table__footer"
              >
                <div
                  v-if="checkShowDetail(item.id)"
                  class="item-documents-table__footer-list"
                >
                  <template v-for="(content, key) in item.contents">
                    <div :key="content.id" class="item-footer">
                      <div class="item-footer__col item-footer__col--info">
                        {{ key + 1 }}.
                        {{
                          currLocale === "en"
                            ? content.name_eng
                            : content.name_rus
                        }}
                      </div>

                      <div class="item-footer__col item-footer__col--count">
                        <nobr>
                          {{ content.quantity }}
                          {{
                            currLocale === "en"
                              ? content.measure_unit_eng
                              : content.measure_unit_rus
                          }}
                        </nobr>
                      </div>

                      <div class="item-footer__col item-footer__col--sum">
                        {{ content.amount | format }}&nbsp;{{
                          getCurrency(item.currency)
                        }}
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  class="item-documents-table__footer-btn"
                  @click="setShowDetail(item.id)"
                >
                  <span v-if="checkShowDetail(item.id)" class="close">
                    {{ $t("event.documents.collapse") }}
                  </span>
                  <span v-else class="open">
                    {{ $t("event.documents.more") }}
                  </span>
                  <icon
                    name="arrow-down-transparent"
                    :class="{
                      top: checkShowDetail(item.id)
                    }"
                  />
                </div>
              </div>
            </div>
          </simplebar>
        </template>
      </div>
    </div>

    <Loader v-if="showLoader" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import apiParticipant from "@/api/participant";
import { Loader, Tooltip } from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";

export default {
  name: "EventModalDocumentsContentActs",
  components: {
    Tooltip,
    Loader
  },
  data() {
    return {
      showLoader: false,
      showDetailState: []
    };
  },
  computed: {
    ...mapState("documents", ["currenciesComparisonTable"]),
    ...mapGetters("documents", ["acts"]),
    ...mapGetters("event", ["eventId", "isServiceShown"]),

    currLocale() {
      return i18n.locale;
    }
  },
  methods: {
    setShowDetail(actId) {
      if (this.showDetailState.find(item => item === actId)) {
        this.showDetailState = this.showDetailState.filter(
          item => item !== actId
        );
      } else {
        this.showDetailState.push(actId);
      }
    },

    checkShowDetail(actId) {
      return this.showDetailState.find(item => item === actId);
    },

    formatDate(date) {
      if (!date) return "";

      return i18n.locale === "ru"
        ? moment(date).format("DD.MM.YYYY")
        : moment(date).format("MM.DD.YYYY");
    },

    getCurrency(currency) {
      if (
        !currency ||
        !this.currenciesComparisonTable ||
        (this.currenciesComparisonTable &&
          !this.currenciesComparisonTable.length)
      ) {
        return "₽";
      }

      const result = this.currenciesComparisonTable.find(
        el => el.code === currency
      );
      if (result) {
        return result.symbol;
      }

      return "₽";
    },

    async downloadFile(actId, actName) {
      try {
        this.showLoader = true;

        const response = await apiParticipant.downloadDocument(
          this.eventId,
          actId
        );
        let blob = new Blob([response], {
          type: "application/pdf"
        });
        const url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = `${actName}.pdf`;
        link.click();
      } finally {
        this.showLoader = false;
      }
    }
  },

  filters: {
    format: val => `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, "$1 ")
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/media";

.documents-info {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 44px;
  box-sizing: border-box;

  .svg-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    color: #cdced0;

    @include respond-down(md) {
      width: 16px;
      height: 16px;
    }
  }
  &__text {
    flex: 1;
    font-size: 13px;
    line-height: 20px;
    color: #000000;

    @include respond-down(md) {
      font-size: 9px;
      line-height: 12px;
    }
  }
}

.documents-table {
  &__row {
    @include respond-down(md) {
      justify-content: flex-end;
      align-items: flex-start;
      padding-top: 10px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }
  &__col {
    @include respond-down(md) {
      padding-left: 3px;
      padding-right: 3px;
    }
    .documents-table__title-mobile {
      @include respond-down(md) {
        margin-bottom: 3px;
      }
    }
    &--number-contract {
      width: 25%;
      padding-left: 26px;
      text-align: left;

      @include respond-down(md) {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 15px;
        text-align: left;
      }
      .documents-table__title-mobile {
        display: inline;
        margin-right: 5px;
        text-align: left;
      }
    }
    &--number-act {
      width: 24%;

      @include respond-down(md) {
        width: 47%;
        padding-left: 0;
        padding-right: 0;
        text-align: left;
      }
      .documents-table__title-mobile {
        margin-right: 3px;
        text-align: left;
      }
    }
    &--date {
      width: 16%;

      @include respond-down(md) {
        width: 18%;
      }
    }
    &--sum-act {
      width: 20%;
    }
    &--download {
      width: 15%;
    }
  }
  &__icon-download {
    @include respond-down(md) {
      margin-bottom: 0;
    }
  }
}

.item-documents-table {
  min-width: 340px;
  overflow-x: auto;

  &__footer {
    .item-footer {
      position: relative;

      @include respond-down(md) {
        padding-left: 8px;
        padding-right: 8px;
      }
      &__col {
        &--info {
          width: 49%;
          padding-left: 26px;
          text-align: left;

          @include respond-down(md) {
            width: 47%;
            padding-left: 0;
          }
        }
        &--count {
          width: 16%;
          text-align: center;

          @include respond-down(md) {
            width: 18%;
          }
        }
        &--sum {
          width: 20%;
        }
      }
      &:after {
        @include respond-down(md) {
          left: 8px;
          right: 8px;
        }
      }
    }
  }

  .ps--active-x & {
    margin-bottom: 8px;
  }
}

.ps--active-x {
  margin-bottom: 20px;

  @include respond-down(lg) {
    margin-bottom: 10px;
  }
  @include respond-down(md) {
    margin-bottom: 19px;
  }
}
</style>
